import { Flex } from "rebass";
import { ColorTooltip } from "../../common/ColorTooltip";
const GridColor = ({ colors, type, onClick, onClose }) => {
  return (
    <Flex
      height="fit-content"
      sx={{
        flexWrap: "wrap",
        width: "100%",
        justifyContent: "space-between",
      }}
    >
      {colors?.map((color, i) => (
        <ColorBox
          id={color.id}
          colorDescription={color.colorDescription}
          type={type}
          code={color.code}
          rgbColor={color.rgb}
          onClick={(event) => {
            onClick(event, color, i);
            onClose();
          }}
        />
      ))}
    </Flex>
  );
};

const ColorBox = ({ onClick, colorDescription, rgbColor, id, type, code }) => {
  return (
    <Flex
      bg="#f3f3f3"
      p="10px"
      justifyContent="center"
      flexDirection="column"
      onClick={onClick}
      sx={{
        width: "calc(50% - 4px)",
        marginBottom: "8px",
      }}
    >
      <span
        style={{
          fontWeight: "bold",
          textAlign: "center",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {colorDescription}
      </span>

      <ColorTooltip
        id={id}
        code={code}
        colorDescription={colorDescription}
        rgb={rgbColor}
        componentName={"catalogueGrillReorderSwapAndPopup"}
        type={type}
      />
    </Flex>
  );
};

GridColor.defaultProps = {
  colors: [],
};

export { GridColor };
